import React, { createContext, useContext, useState, useEffect } from 'react';
import {BASE_URL} from "../config";

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Function to check auth status
    const checkAuthStatus = () => {
        const token = localStorage.getItem('userToken');
        const userInfo = localStorage.getItem('userInfo');

        if (token && userInfo) {
            setCurrentUser({
                token,
                ...JSON.parse(userInfo)
            });
        } else {
            setCurrentUser(null);
        }
    };

    useEffect(() => {
        checkAuthStatus();
        setLoading(false);
    }, []);

    const login = (userData) => {
        localStorage.setItem('userToken', userData.token);
        localStorage.setItem('userInfo', JSON.stringify({
            name: userData.name,
            phone: userData.phone,
            email: userData.email,
            address: userData.address,
            gender: userData.gender
        }));
        localStorage.setItem('loggedIn', 'true');
        setCurrentUser(userData);
    };

    const logout = async () => {

        await fetch(`${BASE_URL}api/v1/logout`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${currentUser.token}`
            }
        });

        localStorage.removeItem('userToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('basket');
        setCurrentUser(null);
    };

    const value = {
        currentUser,
        login,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};